import type { IconData } from '../../types';

export const data: IconData = {
  o: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="m7 15 3-4 3 2 4-5v8H7z"/></g>',
  f: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="m7 15 3-4 3 2 4-5v8H7z"/></g>',
  vb: '0 0 24 24',
};

export default data;
